import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IUser } from "src/services/types";
import { deleteUser, getUsers, updateUser } from "src/services/users-service";
import { columnsUsers } from "./ColumnsUsers";
import { toast } from 'react-toastify';
import { DeleteModalv2 } from "src/components/Common/DeleteModalv2";
import { SearchTable } from "src/components/Common/SearchTable";
import { Col, Row } from "reactstrap";
import { ConfirmDeleteModal } from "../UsersToValidate/ConfirmDeleteModal";
import { OccupationFilter } from "./OccupationFilter";
import { GroupModal } from "../UsersToValidate/GroupModal";
import { NoteModal } from "../UsersToValidate/NoteModal";
import { EditUserModal } from "./EditUserModal";
import { DetailsUserModal } from "./DetailsUserModal";
import { IndicatorsUsersSection } from "./IndicatorsUsersSection";

export const Users = () => {
    document.title = "Secure | Users";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<IUser[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userSelected, setUserSelected] = useState<IUser | null>(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showMoveToGroupModal, setShowMoveToGroupModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);

  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
  });

  const getData = async (config: IConfig) => {
    setIsLoading(true);
    const res = await getUsers(config, true)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res.data.pagination.total);
        setUsers(res.data.data);
        setTotalPage(res.data.pagination.total_pages);
        if(forceUserSelected === 'first') {
          openModal(res.data.data[0], res?.data?.data || []);
        } 
        if(forceUserSelected === 'last') {
          openModal(res.data.data[res.data.data.length - 1], res?.data?.data || []);
        }
        setForceUserSelected(null);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }
  
  const handleActive = async (item: IUser) => {

    const newUsers = users.map((user) => {
          if (user.id === item.id) {
              return { ...user, active: !item.active };
          }
          return user;
      });
      setUsers(newUsers);

      const res = await updateUser(item.id, { active: !item.active });
      if (res.result === 'ok') {
          toast('User updated successfully', { type: 'success'});
      } else {
          toast(res.message, { type: 'error'});
          const newUsers = users.map((user) => {
              if (user.id === item.id) {
                  return { ...user, active: item.active };
              }
              return user;
          });
          setUsers(newUsers);
      }
  }

  const handleVerified = async (item: IUser) => {
    
    const newUsers = users.map((user) => {
        if (user.id === item.id) {
            return { ...user, isVerified: !item.isVerified };
        }
        return user;
    });
    setUsers(newUsers);

    const res = await updateUser(item.id, { isVerified: !item.isVerified });
    if (res.result === 'ok') {
        toast('User updated successfully', { type: 'success'});
    } else {
        toast(res.message, { type: 'error'});
        const newUsers = users.map((user) => {
            if (user.id === item.id) {
                return { ...user, isVerified: item.isVerified };
            }
            return user;
        });
        setUsers(newUsers);
    }
  }

  const openModal = async (item: IUser, usersAux: IUser[] = [] ) => {
    setUserSelected(item);
    setShowUserDetailModal(true);
    if(usersAux.length > 0) {
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
    }
    if((item?.id == (usersAux.length > 0 ? usersAux[0]?.id : users[0]?.id)) && (config.page == 1)) {
      setButtonPrevDisabled(true);
    } else {
      setButtonPrevDisabled(false);
    }

    if((item?.id == (usersAux.length > 0 ? usersAux[usersAux.length - 1]?.id : users[users.length - 1]?.id)) && (config.page == totalPage)) {
      setButtonNextDisabled(true);
    } else {
      setButtonNextDisabled(false);
    }
  }

  const openNoteModal = async (item: IUser) => {
    setUserSelected(item);
    setShowNoteModal(true);
  }

  const onMoveAGroup = async (item: IUser) => {
    setUserSelected(item);
    setShowMoveToGroupModal(true);
  }

  const openEditUserModal = async (item: IUser) => {
    setUserSelected(item);
    setShowEditUserModal(true);
  }

  const onConfirmDelete = async () => {
    if (!userSelected) return;
    
    setLoadingDelete(true);
    const res = await deleteUser(userSelected.id);
    setShowDeleteModal(false);
    if (res.result === 'ok') {
        toast('User deleted successfully', { type: 'success'});
        setUserSelected(null);
        getData(config);
    } else {
        toast(res.message, { type: 'error'});
    }
  }
  const refresh = () => {
    getData(config);
    setForceRefresh(true);
  }

  const onDelete = async (item: IUser) => {
    setUserSelected(item);
    setShowDeletedModal(true);
  }

  const handleChangeOccupation = (occupationId: string) => {
    setConfig({ ...config, occupation_id: occupationId, page: 1 });
  }

  const [forceUserSelected, setForceUserSelected] = useState<'last' | 'first' | null>(null);
  const [buttonNextDisabled, setButtonNextDisabled] = useState(false);
  const [buttonPrevDisabled, setButtonPrevDisabled] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  
  const onPrevUser = async() => {
    setButtonNextDisabled(false);
    const index = users.findIndex(u => u.id === userSelected?.id);
    if (index > 0) {
      setUserSelected(users[index - 1]);
    } else if (config.page > 1) {
      setForceUserSelected('last');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page - 1 });
    }
    if(index === 1 && config.page === 1) {
      setButtonPrevDisabled(true);
    }
  }
  const onNextUser = async() => {
    setButtonPrevDisabled(false);
    const index = users.findIndex(u => u.id === userSelected?.id);
    if (index < users.length - 1) {
      setUserSelected(users[index + 1]);
    } else {
      setForceUserSelected('first');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page + 1 });
    }
  }

  useEffect(() => {
    getData(config);
  }, [config]);

  return (
    <>
      <div className="page-content">
          <IndicatorsUsersSection onRefresh={refresh} setForceRefresh={() => setForceRefresh(false)} forceRefresh={forceRefresh} />
          <h2 className="text-primary" style={{marginBottom: '20px'}}>Users</h2>
          <Row className="mb-2">
              <Col sm={6} className="d-flex align-items-end justify-content-start gap-2">
                <OccupationFilter
                    onOccupationChange={handleChangeOccupation}
                    label="Filter by Occupation"
                />
                <div>
                    <button
                        type="button"
                        className="btn btn-soft-primary waves-effect waves-light"
                        onClick={refresh}
                    >
                        <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                </div>
                </Col>
              <Col sm={6} className="d-flex justify-content-end align-items-end" >
                  <div className="w-75">
                    <SearchTable 
                        onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                        loading={isLoading && !!config.search}
                    />
                  </div>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                customStyles={{
                    rows: { style: { minHeight: '50px' }},
                    table: { style: { minHeight: '400px'}},
                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                }}
                columns={columnsUsers(config, handleActive, handleVerified, openModal, onDelete, onMoveAGroup, openNoteModal, openEditUserModal)}
                data={users}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                responsive
                onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                onChangePage={(page) => setConfig({ ...config, page })}
                paginationDefaultPage={config.page}
                paginationPerPage={config.per_page}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                noDataComponent={
                    <SectionNoData
                        onRefresh={() => getData(config)}
                        isLoading={isLoading}
                    />
                }
              />
          </ContentDataTable>
      </div>
      
      <DeleteModalv2
        show={showDeleteModal}
        loading={loadingDelete}
        title={"Delete User "+ userSelected?.firstName + " " + userSelected?.lastName}
        content="Are you sure you want to delete this user?. This action cannot be undone."
        onCancel={setShowDeleteModal}
        onDelete={() => onConfirmDelete()}
      />

        <DetailsUserModal
            isViewUser
            activeButtonsNextPrev
            show={showUserDetailModal}
            onClose={() => (setUserSelected(null), setShowUserDetailModal(false))}
            userId={userSelected?.id!}
            onPrev={onPrevUser}
            onNext={onNextUser}
            buttonNextDisabled={buttonNextDisabled}
            buttonPrevDisabled={buttonPrevDisabled}
        />

        <ConfirmDeleteModal
            show={showDeletedModal}
            onClose={() => setShowDeletedModal(false)}
            onRefresh={refresh}
            user={userSelected!}
        />

        <GroupModal 
            show={showMoveToGroupModal}
            onClose={() => setShowMoveToGroupModal(false)}
            onRefresh={refresh}
            item={userSelected!}
        />

        <NoteModal 
            show={showNoteModal}
            onClose={() => setShowNoteModal(false)}
            onRefresh={refresh}
            item={userSelected!}
        />

        <EditUserModal 
            show={showEditUserModal}
            onClose={() => setShowEditUserModal(false)}
            onRefresh={refresh}
            item={userSelected!}
        />

    </>
  )
}
